<a
    href="{{ linkedinUrl }}"
    class="pill pill--linkedin">
    <i class="uil uil-linkedin"></i>
    LinkedIn
</a>
